let React               = require("react");
let AssetCard           = require("./generic/AssetCard.jsx");
let MetaDataPackageCard = require("./MetaDataPackageCard.jsx");
let ExportPackageButton = require("../buttons/ExportPackageButton.jsx");
let AssetDetailsLink    = require("../../controls/buttons/AssetDetailsLink.jsx");
let DeleteButton        = require("../buttons/DeleteButton.jsx");

let CircuitsUtil        = require("./../../util/CircuitsUtil.js");
let ApplicationContext  = require("./../../config/ApplicationContext.js");

class PackageCard extends React.Component {
    
    constructor(){
        super();
        this.state = {objUrl: {}};

        this.getFootprintThumbnail = this.getFootprintThumbnail.bind(this);
    }

    componentWillMount(){
        let {id, name } = this.props.resource;
        let pathname = CircuitsUtil.getViewUrl("packages", id, name);
        this.setState({objUrl: {pathname, state: { modal: true, previousView: location.pathname }}});
    }

    getFootprintThumbnail(id){
        const { resource, handleError } = this.props;
        const data = resource?.thumbnail2d ? resource : id;
        return CircuitsUtil.getFootprintThumbnail(handleError, data);
    }

    render() {
        // Package Cards default button layout
        const { 
                hubDeleted = false,
                Buttons = {
                    grid:{
                        default:[
                            DeleteButton,
                            ExportPackageButton,
                        ]
                    },
                    list:{
                        default: [
                            ExportPackageButton,
                            DeleteButton
                        ]
                    }
                },
                Action = props => <AssetDetailsLink {...props} objUrl={this.state.objUrl}/>
            } = this.props;


        return <AssetCard
                    {...this.props}
                    Action={Action}
                    Buttons={hubDeleted? {grid: {default: []}, list: {default: []}}: Buttons}
                    urlName="packages"
                    cssCardTag="package"
                    requireVersion = {true}
        			      InfoOverlay={MetaDataPackageCard}
                    switchThumbnail={{show: this.props.switchThumbnail,
                                    thumbnails: [ {name: "2D", onClick: this.getFootprintThumbnail},
                                                    {name: "3D", onClick: null, selected: true}]}}
        		/>;
    }
}

module.exports = PackageCard;
